import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import meridianpage from '@/components/meridianpage'
import feastpage from '@/components/feastpage'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/meridianpage',
      name: 'meridianpage',
      component: meridianpage
    },
    {
      path: '/feastpage',
      name: 'feastpage',
      component: feastpage
    },
    {
      path:'*',
      redirect:'/'
    }
  ]
})
